import * as ActionTypes from './actionTypes'

// Set Locale Action
export function setLocale(locale) {
  return dispatch => {
    dispatch({ type: ActionTypes.SET_LOCALE, payload: locale })
  }
}